import {
  Box,
  FormControlLabel,
  IconButton,
  Radio,
  Slider,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { useMediaQuery } from "react-responsive";
import Files from "react-files";
import Title from "../add/title";
import CloseIcon from "@mui/icons-material/Close";
const SubmitServiceItem = ({
  index,
  detail,
  formData,
  handleChange,
  setData,
  uploadOption,
  setUploadOption,
}) => {
  const fonts = ["Mockads", "Escopedia", "Great Vibes"];
  const colors = ["#FFFFFF", "#303030", "#ECA601"];

  const defaultColor = "#FFFFFF";
  const defaultFontFamily = "Mockads";
  const defaultFontSize = 30;
  const isPortable = useMediaQuery({ query: "(max-width:1200px)" });
  const handleFontChange = (index, font) => {
    handleChange(index, "selectedFont", font);
  };

  const handleColorClick = (index, color) => {
    handleChange(index, "selectedColor", color);
  };

  const handleFontSizeChange = (index, event, newValue) => {
    handleChange(index, "fontSize", newValue);
  };

  const handleFileChange = (files) => {
    if (files && files.length > 0) {
      setData((prev) => ({ ...prev, [`logo_${index}`]: files[0] }));
    }
  };

  const handleUploadOptionChange = (option) => {
    setUploadOption(option);
    if (option === "customLogo") {
      setData((prev) => ({ ...prev, [`customlogoName_${index}`]: "" }));
    } else {
      setData((prev) => ({ ...prev, [`logo_${index}`]: null }));
    }
  };

  const toggleUploadOption = () => {
    if (uploadOption === "logo") {
      handleUploadOptionChange("customLogo");
    } else {
      handleUploadOptionChange("logo");
    }
  };

  return (
    <Box key={index} sx={{ mb: 4 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Detail for {detail.name} service {++index}:
      </Typography>
      {
        detail.is_days &&
        <TextField
            fullWidth
            label="Days"
            name="count"
            type={"number"}
            required
            autoComplete="off"
            value={formData[`count_${index}`] || ""}
            onChange={(e) => {
              handleChange(index, "count", e.target.value);
            }}
            variant="outlined"
            InputLabelProps={{
              shrink: Boolean(formData[`count_${index}`]),
            }}
            sx={{ mb: 2 }}
        />
      }
      {
        detail.is_tickets &&
        <TextField
            fullWidth
            label="Tickets"
            name="count"
            type={"number"}
            required
            autoComplete="off"
            value={formData[`count_${index}`] || ""}
            onChange={(e) => {
              handleChange(index, "count", e.target.value);
            }}
            variant="outlined"
            InputLabelProps={{
              shrink: Boolean(formData[`count_${index}`]),
            }}
            sx={{ mb: 2 }}
        />
      }

      {detail.FiledTitle && (
        <TextField
          fullWidth
          required
          label={`Title`}
          value={formData[`title_${index}`] || ""}
          onChange={(e) => handleChange(index, "title", e.target.value)}
          sx={{ mb: 2 }}
        />
      )}
      {detail.FiledDescription && (
        <TextField
          fullWidth
          multiline
          minRows={1}
          variant="outlined"
          InputLabelProps={{
            style: { color: "#434343", fontSize: "13px" },
          }}
          sx={{
            mb: 2,
            background: "white",
            borderRadius: "8px",
            "& .MuiOutlinedInput-root": {
              border: "1px solid #5F5F5F",
              boxShadow: "-2px 2px 4px #00000040",
              borderRadius: "8px",
              "& fieldset": {
                border: "none",
              },
              "& textarea": {
                borderRadius: "10px",
              },
            },
          }}
          required
          label={`Description`}
          value={formData[`description_${index}`] || ""}
          onChange={(e) => handleChange(index, "description", e.target.value)}

        />
      )}
      {(detail.name === "Pin Up" || detail.name === "Pin Down") && (
        <TextField
          fullWidth
          required
          label={`Priority`}
          value={formData[`priority_${index}`] || ""}
          onChange={(e) => {
            handleChange(index, "priority", e.target.value);
          }}
          sx={{ mb: 2 }}
        />
      )}
      {detail.FiledImage && (
        <div className="logo-container">
          <Title title="Logo Image *" />
          <div className="switcher">
            <FormControlLabel
              control={
                <Switch
                  checked={uploadOption === "customLogo"}
                  onChange={toggleUploadOption}
                  name="uploadOptionSwitch"
                />
              }
              label={
                uploadOption === "logo"
                  ? "Switch to Custom Logo"
                  : "Switch to Photo Upload"
              }
            />
          </div>
          <div className="logo-ways-container">
            {detail.FiledImage &&
              ((isPortable && uploadOption === "logo") || !isPortable) && (
                <Box
                  sx={{
                    width: "100%",
                    opacity: uploadOption === "customLogo" ? 0.5 : 1,
                    pointerEvents:
                      uploadOption === "customLogo" ? "none" : "auto",
                  }}
                >
                  <div
                    className="custom-logo "
                    style={{
                      cursor:
                        uploadOption === "customLogo"
                          ? "not-allowed"
                          : "pointer",
                    }}
                  >
                    <Files
                      onChange={(fileList) => handleFileChange(fileList)}
                      onError={(error) =>
                        console.error("File upload error:", error)
                      }
                      accepts={["image/*"]}
                      clickable
                      multiple={false}
                      maxFileSize={10485760} // 10MB limit
                      disabled={uploadOption === "customLogo"}
                      className="files"
                    />
                    {formData[`logo_${index}`] ? (
                      <div className="selected-logo-container">
                        <img
                          src={URL.createObjectURL(formData[`logo_${index}`])}
                          alt="Uploaded Logo"
                          className="selected-logo-img"
                        />
                        <IconButton
                          onClick={() => {
                            setData((prev) => ({
                              ...prev,
                              [`logo_${index}`]: null,
                            }));
                          }}
                          className="selected-logo-remove"
                        >
                          <CloseIcon />
                        </IconButton>
                      </div>
                    ) : (
                      <Typography
                        variant="body2"
                        className="text-textColor dark:text-darkTextColor"
                      >
                        Click to upload a logo
                      </Typography>
                    )}
                  </div>
                </Box>
              )}
            {detail.FiledImage &&
              ((isPortable && uploadOption === "customLogo") ||
                !isPortable) && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    opacity: uploadOption === "logo" ? 0.5 : 1,
                  }}
                >
                  <Box
                    sx={{
                      opacity: 1,
                      pointerEvents: "auto",
                      border: "1px solid #303030",
                      borderRadius: "10px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      fullWidth
                      sx={{
                        display: "flex",
                        flexDirection: {
                          xs: "column",
                          sm: "row",
                          md: "column",
                          lg: "row",
                        },
                        justifyContent: {
                          xs: "space-between",
                          sm: "space-around",
                          md: "space-between",
                        },
                        alignItems: "center",
                        height: "100%",
                        width: "100%",
                        padding: "20px 20px",
                      }}
                    >
                      <Box
                        fullWidth
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "10px",
                          width: "100%",
                        }}
                      >
                        <Box>
                          <Typography>Pick a Custom Logo</Typography>
                          <TextField
                            fullWidth
                            variant="outlined"
                            value={formData[`customlogoName_${index}`] || ""}
                            onChange={(e) =>
                              handleChange(
                                index,
                                "customlogoName",
                                e.target.value
                              )
                            }
                            placeholder="Type Your Logo Name here"
                            size="small"
                            sx={{
                              width: "95%",
                              boxShadow: "-2px 2px 4px #00000040",
                              borderRadius: "10px",
                              marginTop: "10px",
                            }}
                          />
                        </Box>

                        {/* Font Selection */}
                        <Box>
                          <Typography>Choose a Font</Typography>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              gap: "10px",
                              marginTop: "4px",
                              justifyContent: "space-evenly",
                            }}
                          >
                            {fonts.map((font) => (
                              <Box
                                key={font}
                                onClick={() => handleFontChange(index, font)}
                                sx={{
                                  background: "#E5EDFF",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  flexDirection: "column",
                                  gap: "4px",
                                  border: "1px solid #959595",
                                  borderRadius: "10px",
                                  padding: {
                                    xs: "4px 6px",
                                    sm: "4px 12px",
                                    md: "4px 25px",
                                  },
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontFamily: font.includes(" ")
                                      ? `'${font}'`
                                      : font, // Fix for spaces
                                  }}
                                >
                                  lorem
                                </Typography>
                                <Radio
                                  checked={
                                    formData[`selectedFont_${index}`]
                                      ? formData[`selectedFont_${index}`] ===
                                        font
                                      : defaultFontFamily === font
                                  }
                                  onChange={() => handleFontChange(index, font)}
                                  sx={{ color: "primary.main" }}
                                />
                              </Box>
                            ))}
                          </Box>
                        </Box>

                        {/* Color and Font Size Selection */}
                        <Typography>Choose a color and font size</Typography>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "6px",
                            }}
                          >
                            <Box sx={{ display: "flex", gap: 2 }}>
                              {colors.map((color) => (
                                <Box
                                  key={color}
                                  onClick={() => handleColorClick(index, color)}
                                  sx={{
                                    width: 20,
                                    height: 20,
                                    borderRadius: "50%",
                                    backgroundColor: color,
                                    cursor: "pointer",
                                    border: `1px ${
                                      (
                                        formData[`selectedColor_${index}`]
                                          ? formData[
                                              `selectedColor_${index}`
                                            ] === color
                                          : defaultColor === color
                                      )
                                        ? "blue"
                                        : "#303030"
                                    } solid`,
                                    transition: "border 0.3s ease",
                                  }}
                                />
                              ))}
                            </Box>
                          </Box>

                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "6px",
                            }}
                          >
                            <Slider
                              value={
                                formData[`fontSize_${index}`] || defaultFontSize
                              }
                              onChange={(e, value) =>
                                handleFontSizeChange(index, e, value)
                              }
                              min={20}
                              max={40}
                              step={1}
                              valueLabelDisplay="auto"
                              sx={{ width: "100px" }}
                            />
                          </Box>
                        </Box>

                        {/* Logo Preview */}
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: "6px",
                            height: "200px",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "18px",
                              lineHeight: "28px",
                              color: "#474747",
                            }}
                          >
                            Your Logo Demo
                          </Typography>
                          <Box
                            sx={{
                              background:
                                "radial-gradient(circle, #51AAFD, #002D68)",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              position: "relative",
                              overflow: "hidden",
                              padding: {
                                xs: "40px",
                                sm: "40px 20px",
                                md: "40px",
                              },
                              borderRadius: "15px",
                              width: "130px",
                              height: "100px",
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: `${
                                  formData[`fontSize_${index}`] ||
                                  defaultFontSize
                                }px`,
                                fontWeight: "700",
                                color:
                                  formData[`selectedColor_${index}`] ||
                                  defaultColor,
                                fontFamily:
                                  formData[`selectedFont_${index}`] ||
                                  defaultFontFamily,
                              }}
                            >
                              {formData[`customlogoName_${index}`] || "LOREM"}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              )}
          </div>
        </div>
      )}
    </Box>
  );
};

export default SubmitServiceItem;
